import { ActionStatus } from '@common/constants/shared';
import { MetadataAction } from '@common/types/action';
import { get, isEmpty } from 'lodash';
import { ActionResponse } from '../excuteAction';
import { sendEventAnalytics } from './trackingAnalytics';
import { ActionType } from 'click-types';

export const createObject: (
  action: any,
  metadata: MetadataAction
) => Promise<ActionResponse> = async (
  action: any,
  metadata: MetadataAction
) => {
  const { messages } = metadata;

  if (action.status === ActionStatus.ERROR) {
    return {
      status: ActionStatus.FAILED,
      message: get(action, 'error.message'),
    };
  }

  const recordCreated = action.response;

  const currentRecordIds = { [recordCreated?.databaseId]: recordCreated?.id };

  const isTrackingEnabled =
    metadata.actionItem?.options?.trackAnalytics === true;
  if (isTrackingEnabled) {
    try {
      const formData = {
        record_id: recordCreated?.id,
        database_id: recordCreated?.databaseId,
        ...metadata.record,
        datasourceId: metadata.actionItem?.options?.datasourceId,
        tableId: metadata.actionItem?.options?.tableId,
      };

      await sendEventAnalytics({
        actionType: ActionType.CreateObject,
        id: 'createObject',
        options: {
          eventName: metadata.actionItem?.options?.eventName || 'click_create_object',
          formData: formData,
          fbPixelContentName:
            metadata.actionItem?.options?.eventName || 'Object Creation',
          fbPixelContentCategory: 'Lead Generation',
        },
        status: 'success',
      });
    } catch (error) {
      console.warn('Create object tracking failed:', error);
    }
  }

  return {
    status: ActionStatus.SUCCESS,
    message: messages['database_created_record'],
    recordCreated,
    ...(!isEmpty(currentRecordIds) && { currentRecordIds }),
  };
};
